import React, { useCallback } from 'react';
import * as Mui from '@mui/material';
import { DatePicker as MuiDatePicker, DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { RenderFieldProps } from '@/types/form';

const FDatePicker = ({ field, value, id, onChange }: RenderFieldProps) => {
  const handleDateChange = useCallback(
    (date: Dayjs | null) => {
      if (date) {
        onChange(id, date.toDate().toISOString());
      }
    },
    [id, onChange]
  );

  return (
    <Mui.FormControl fullWidth margin="normal">
      {field.type === "date" && field.withTime ? (
        <MuiDateTimePicker
          label={field.label}
          value={value ? dayjs(value) : null}
          onChange={handleDateChange}
        />
      ) : (
        <MuiDatePicker
          label={field.label}
          value={value ? dayjs(value) : null}
          onChange={handleDateChange}
        />
      )}
    </Mui.FormControl>
  );
};

export default React.memo(FDatePicker);
